import { CurrencyProp } from "../WidgetRevampv2/types";

export const WIDGET_RESPONSE_STATUSES = {
  success: "success",
  error: "error",
  cancel: "cancel",
};

export const localCurrency = (isoCode: string): CurrencyProp | '' => {
  if (isoCode) {
    if (isoCode === "NG") {
      return "NGN";
    } else {
      return "KSH";
    }
  } else {
    return "";
  }
};
